<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <div>
          <h1 class="page-title">{{ $t('Simulations') }}</h1>
          <h2 class="page-subtitle">{{ $t('Total') }} : {{ totalCount }}</h2>
        </div>
        <b-button v-if="allowCreate" variant="primary" @click="clickOnCreateBtn">
          <plus-icon class="mr-1" size="18"/>
          {{ $t('Add') }} {{ $t('a.e') }} {{ $t('simulation') }}
        </b-button>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b122-table
          ref="B122TableSimulation"
          :deleteItem=allowDelete
          :editItem=allowEdit
          :empty-button="$t('simulation.emptyButton').toString()"
          :empty-text="$t('simulation.emptyText').toString()"
          :empty-title="$t('simulation.emptyTitle').toString()"
          :fields="tableFields"
          get-b122-table-results-url="/simulation/getB122TableResults"
          identifier="B122TableSimulation"
          init-b122-table-url="/simulation/initB122Table"
          @add="clickOnCreateBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn"
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnShowBtn="clickOnShowBtn"
          @setFilters="setFilters"
          @setTotalCount="setTotalCount">

          <template #cell(viable)="data">
            <check-icon v-if="data.item.viable" size="26"></check-icon>
            <x-icon v-else class="viability-icon-nonviable" size="24"></x-icon>
          </template>

          <template #cell(operationLinked)="data">
            <check-icon v-if="data.item.operationId" size="26"></check-icon>
            <x-icon v-else class="viability-icon-nonviable" size="24"></x-icon>
          </template>

          <template #cell(actions)="row">
            <div class="actions-container text-right">
              <b-button class="mr-1 duplicate" variant="outline-primary" @click=clickOnCopyBtn(row)>
                <copy-icon size="18"/>
              </b-button>
              <button class="show-action-btn edit mr-1" @click=clickOnEditBtn(row)>
                <pencil-icon size="18"/>
              </button>
              <button v-if="isEstateAgent || row.item.estateAgent.username === username" class="show-action-btn delete"
                      @click=clickOnDeleteBtn(row)>
                <trash-icon size="18"/>
              </button>
            </div>
          </template>

        </b122-table>
      </b-card>
    </b-container>

    <Item-delete-modal
      :isFeminine=true
      :selectedItem="ui.selectedSimulation"
      controllerName="simulation"
      itemSingularName="simulation"
      itemSingularNameUpp="Simulation"
      @didDeleteItem="didDeleteSimulation()">
    </Item-delete-modal>

  </div>
</template>

<script>

import B122Table from '../../components/b122/B122Table'
import ItemDeleteModal from '../../components/b122/ItemDeleteModal'
import api from "../../services/api";

export default {

  name: 'SimulationIndex',

  components: {
    B122Table,
    ItemDeleteModal
  },

  data() {
    return {
      isFirstConnexion: false,
      username: this.$store.getters.username,
      isEstateAgent: this.$store.getters.isEstateAgent,
      isCollaborator: this.$store.getters.isCollaborator,
      isCollaboratorPlus: this.$store.getters.isCollaboratorPlus,
      totalCount: 0,
      allowCreate: true,
      allowDelete: true,
      allowEdit: true,
      urbanStudyId: this.$route.params.urbanStudyId,

      ui: {
        selectedSimulation: null
      }

    }
  },

  mounted() {
    this.manageIsFirstConnexion()
  },

  computed: {

    tableFields() {
      return [
        {
          label: this.$i18n.t('Show'),
          key: 'show',
          sortable: false
        },
        {
          label: this.$i18n.t('simulation.Name'),
          key: 'name',
          sortable: true
        },
        {
          label: this.$i18n.t('simulation.Dossier'),
          key: 'dossier',
          sortable: true
        },
        {
          label: this.$i18n.t('simulation.PrixAchat'),
          key: 'prixAchat',
          sortable: true,
          formatter: function (value) {
            return Intl.NumberFormat().format(value.toFixed(0)) + " €"
          }
        },
        {
          label: this.$i18n.t('simulation.CreationDate'),
          key: 'creationDate',
          sortable: true,
          formatter: function (value) {
            return new Date(value).toLocaleString('fr-FR')
          }
        },
        {
          label: this.$i18n.t('simulation.Viable'),
          key: 'viable',
          sortable: false
        },
        {
          label: this.$i18n.t('simulation.OperationLinked'),
          key: 'operationLinked',
          sortable: false
        },
        {
          label: this.$i18n.t('simulation.Benefice'),
          key: 'benefice',
          sortable: false,
          formatter: function (value) {
            return Intl.NumberFormat().format(value.toFixed(0)) + " €"
          }
        },
        {
          label: this.$i18n.t('simulation.Marge'),
          key: 'marge',
          sortable: false,
          formatter: function (value) {
            return value + '%'
          }
        },
        {
          label: '',
          key: 'actions'
        }
      ]
    }

  },

  methods: {

    manageIsFirstConnexion() {
      if(!this.$store.getters.impersonateUsername){
        api
          .get(`/user/isFirstConnexion/${this.$store.getters.userId}`)
          .then(response => {
            this.isFirstConnexion = response.data.isFirstConnexion
            if (this.isFirstConnexion) {
              this.showOnBoardingModal()
            }
          })
      }
    },

    showOnBoardingModal() {
      this.$bvModal.show('first-connexion-modal')
    },

    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    setFilters() {
      if (this.$route.params.urbanStudyId) {
        this.$refs.B122TableSimulation.filters.find(item => {
          if (item.position === 2) {
            item.selectedValue = this.$route.params.urbanStudyId
          }
        })
      }
    },

    clickOnCreateBtn() {
      this.$router.push({
        name: 'SimulationCreateEdit'
      })
    },

    clickOnShowBtn(row) {
      this.$router.push({
        name: 'SimulationShow',
        params: {
          simulationId: row.item.id
        }
      })
    },


    clickOnEditBtn(row) {
      this.ui.selectedSimulation = row.item
      this.$router.push({
        name: 'SimulationCreateEdit',
        params: {
          simulationId: row.item.id,
          isOperationLinked: !!row.item.operationId,
          operationId: row.item.operationId
        }
      })
    },

    clickOnCopyBtn(row) {
      this.$confirm(this.$i18n.t('duplicate.confirm').toString()).then(() => {
        this.duplicate(row)
      });
    },

    duplicate(row) {
      api
        .get(`/simulation/duplicate/${row.item.id}`)
        .then(() => {
          this.$refs.B122TableSimulation.refreshTable()
          this.successToast()
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'SimulationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },


    clickOnDeleteBtn(row) {
      this.ui.selectedSimulation = row.item
      if (this.ui.selectedSimulation && this.ui.selectedSimulation.operationId) {
        this.$alert(this.$i18n.t('simulation.cant.delete.operation.linked', {simulationName: this.ui.selectedSimulation.tostring}).toString()).then(() => {
        });
      } else {
        this.$bvModal.show('item-delete-modal')
      }
    },

    didDeleteSimulation() {
      this.ui.selectedSimulation = null
      this.$refs.B122TableSimulation.refreshTable()
    },

    successToast() {
      this.$bvToast.toast(this.$i18n.t('duplicate.success'), {
        autoHideDelay: 5000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    }

  }
}
</script>

<style scoped>
.duplicate {
  padding: 2px 6px 3px;
}
</style>



// WEBPACK FOOTER //
// src/views/simulation/SimulationIndex.vue